require('./stocksBanner.scss');
const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');
const { connect } = require('react-redux');
const { formatAmount } = require('utilities/currencyHelper');

const { MIN_EXCHAGE_INDEXES } = require('constants/index');

class StocksBanner extends React.Component {

    buildItems() {

        const { immBrokerExchangeIndexes } = this.props;
        const immIndexes = immBrokerExchangeIndexes.get('indexes');
        const orderIsin = ['FR0010251744', 'LU0252633754', 'NL0009272749', 'LU1681047236', 'LU1681046931', 'FR0010010827'];
        const orderedIndexes = [];
        orderIsin.map((isin) => {
            orderedIndexes.push(...immIndexes.toJS().filter((index) => isin === index.instrumentId))
        });
        let stockTicker = orderedIndexes.concat(orderedIndexes).concat(orderedIndexes).concat(orderedIndexes);

        if (stockTicker && stockTicker.length <= MIN_EXCHAGE_INDEXES){
            stockTicker = stockTicker.concat(stockTicker).concat(stockTicker).concat(stockTicker);
        }

        return stockTicker.map( (item, index) => {
            const variationClassName = classNames({
                'stocks-banner__variation--up': item.upOrDown === 'up',
                'stocks-banner__variation--dw': item.upOrDown === 'down'
            });
            return (
                <div className="stocks-banner__stock" key={index}>
                    <span className="stocks-banner__name">
                        {item.instrumentTranslated}
                    </span>
                    <span className={variationClassName}>
                        <span>{formatAmount(item.variationPct)} %</span>
                    </span>
                </div>
            );
        });
    }

    render() {
        let items;

        if (this.props.immBrokerExchangeIndexes.get('hasBeenFetched')) {
            items = this.buildItems();
        }

        return (
            <div className="stocks-banner">
                <div className="stocks-banner__container">
                    <div className="stocks-banner__collection">
                        {items}
                    </div>
                    <div className="stocks-banner__shadow stocks-banner__shadow--left"></div>
                    <div className="stocks-banner__shadow stocks-banner__shadow--right"></div>
                </div>
            </div>
        );
    }
}

StocksBanner.propTypes = {
    immBrokerExchangeIndexes: PropTypes.object
};

module.exports.constructor = StocksBanner;
module.exports.StocksBanner = connect(
    (state) => ({
        immBrokerExchangeIndexes: state.brokerTickerExchangeIndexes,
    })
)(StocksBanner);
